@use '../../styling/colors.scss' as *;

.LogItem {
  word-break: break-word;
  white-space: normal;
  font-family: monospace;
  color: $theme-color-text;

  // severity
  &.ALERT {
    color: $color-log-alert;
  }

  &.CRITICAL {
    color: $color-log-critical;
  }

  &.DEBUG {
    color: $color-log-debug;
  }

  &.EMERGENCY {
    color: $color-log-emergency;
  }

  &.ERROR {
    color: $color-log-error;
  }

  &.INFORMATIONAL {
    color: $theme-color-text;
  }

  &.NOTICE {
    color: $color-log-notice;
  }

  &.WARNING {
    color: $color-log-warning;
  }

  // stages, overrides severity
  &.SNIPPET {
    color: $color-log-snippet;
    padding-left: 1em;

    &.ERROR {
      color: $color-log-error;
    }
  }

  &.INITIALISING {
    color: $color-log-initialising;

    &.ERROR {
      color: $color-log-error;
    }
  }
}
